import { createBrowserRouter, Navigate, RouterProvider, useRouteError } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "./App.css"
import { LoginForm } from "./features/auth/login-form.tsx"
import { Dashboard } from "./features/home/dashboard.tsx"
import { ErrorPage } from "./features/home/error.tsx"
import { TopReport } from "./features/top-report/top-report.tsx"

import { ConfigurationPage } from "./features/admin/configuration.tsx"
import { OrganizationsPage } from "./features/admin/organizations.tsx"
import { DataSourcesAdminPage } from "./features/admin/data-sources.tsx"
import { DepartmentsAdminPage } from "./features/admin/departments.tsx"
import { OrganizationGroupsPage } from "./features/admin/organization-groups.tsx"
import { OrganizationGroupEditPage } from "./features/organization-group/organization-group-edit-page.tsx"
import { CallTypeEditPage } from "./features/call-type/call-type-edit-page.tsx"
import FactTrendsReport from "./features/fact-trends-report/fact-trends-report.tsx"
import { OperatorReport } from "./features/operator-report/operator-report.tsx"
import { SettingsPage } from "./features/settings/settings-page.tsx"
import { AdminLayout } from "./layout/admin-layout.tsx"
import { Layout } from "./layout/layout"

const BubbleError = () => {
  throw useRouteError()
}
const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Navigate to="/app/dashboard" replace />,
    },
    {
      path: "/login",
      Component: LoginForm,
    },
    {
      path: "/app",
      Component: Layout,
      errorElement: <BubbleError />,
      children: [
        {
          path: "error",
          Component: ErrorPage,
        },
        {
          path: "dashboard",
          Component: Dashboard,
        },
        {
          path: "top",
          Component: TopReport,
        },
        {
          path: "operator-report",
          Component: OperatorReport,
        },
        {
          path: "fact-trends-report",
          Component: FactTrendsReport,
        },
        {
          path: "settings",
          Component: SettingsPage,
        },
      ],
    },
    {
      path: "/app/admin",
      Component: AdminLayout,
      errorElement: <BubbleError />,
      children: [
        {
          index: true,
          element: <Navigate to="organizations" replace />,
        },
        {
          path: "organizations",
          Component: OrganizationsPage,
        },
        {
          path: "data-sources",
          Component: DataSourcesAdminPage,
        },
        {
          path: "departments",
          Component: DepartmentsAdminPage,
        },
        {
          path: "organization-groups",
          Component: OrganizationGroupsPage,
        },
        {
          path: "organization-groups/:id",
          Component: OrganizationGroupEditPage,
        },
        {
          path: "call-types/:id",
          Component: CallTypeEditPage,
        },
        {
          path: "configuration",
          Component: ConfigurationPage,
        },
      ],
    },
  ],
  { basename: "/" },
)

const App = () => {
  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer position="bottom-right" autoClose={4000} />
    </>
  )
}

export default App
